export const portRateConstants = {
    PORT_RATE_FETCHING: 'PORT_RATE_FETCHING',
    PORT_RATE_FETCHED: 'PORT_RATE_FETCHED',
    GET_ALL_PORT_RATES: 'GET_ALL_PORT_RATES',
    GET_PORT_RATES: 'GET_PORT_RATES',
    GET_PORT_RATE_BY_ID: 'GET_PORT_RATE_BY_ID',
    UPDATE_PORT_RATE: 'UPDATE_PORT_RATE',
    SEARCH_PORT_RATES: 'SEARCH_PORT_RATES',
    PORTRATE_GROUP_BY_CHARGE: 'PORTRATE_GROUP_BY_CHARGE',
    PORTRATE_BY_CHARGE: 'PORTRATE_BY_CHARGE',
}